export default __webpack_public_path__ + "6_scroll_mobile_pl.png";